
export const WAREHOUSE_API_URL = ((warehouseApiUrl, reactAppEnv) => {
  // For CI testing environment, hardcode a hostname
  // otherwise this will change in every environment and cause
  // snapshots to false negative fail.
  if (process.env.NODE_ENV === 'test') { return 'http://localhost'; }

  if (window && window.__MODSY_WAREHOUSE_API_URL) {
    return window.__MODSY_WAREHOUSE_API_URL;
  }

  if (warehouseApiUrl) {
    return warehouseApiUrl;
  }

  if (reactAppEnv) {
    switch (reactAppEnv) {
      case 'dev':
        return 'https://www.warehouse.dev.modsy.com';
      case 'staging':
        return 'https://www.warehouse.staging.modsy.com';
      case 'prod':
        return 'https://www.warehouse.modsy.com';
      default:
        return warehouseApiUrl;
    }
  }
  return 'http://localhost:8000';
})(process.env.REACT_APP_WAREHOUSE_API_URL, process.env.REACT_APP_ENV);

// The client URL for inter-app redirects (e.g. WP marketing site).
export const WAREHOUSE_CLIENT_URL = ((reactAppEnv) => {
  switch (reactAppEnv) {
    case 'dev':
      return 'https://www.dev.modsy.com';
    case 'staging':
      return 'https://www.staging.modsy.com';
    case 'prod':
      return 'https://www.modsy.com';
    // this presumes you are running warehouse-client on 3000
    default:
      return process.env.REACT_APP_WAREHOUSE_CLIENT_URL || 'http://localhost:3000';
  }
})(process.env.REACT_APP_ENV);

// Can set product search URL via environment variable.
// If unset, defaults to the warehouse URL.
export const PRODUCT_SEARCH_API_URL = ((productSearchApiUrl) => {
  if (productSearchApiUrl) {
    return productSearchApiUrl;
  }

  return WAREHOUSE_API_URL;
})(process.env.REACT_APP_PRODUCT_SEARCH_API_URL);

const ApiConfig = {
  BASE: `${WAREHOUSE_API_URL}/warehouse/api`,
  get SPACE_INFO () {
    return `${this.BASE}/styleboardinfo`;
  },
  STYLEBOARD_INFO (styleboardId) {
    return `${this.BASE}/styleboardinfo/${styleboardId}?ppo=1`;
  },
  CUSTOM_PROPS (spaceId) {
    return `${this.BASE}/v1/space_custom_prop/${spaceId}`;
  },
  get CREATE_EMPTY_CUSTOM_PROP () {
    return `${this.BASE}/v1/custom_prop/create_empty_custom_prop`;
  },
  get SURVEY_ADDTIONAL_QUESTIONS () {
    return `${WAREHOUSE_API_URL}/api/survey-additional-questions`;
  },
  GET_SPACE (spaceId) {
    return `${this.BASE}/spaces/${spaceId}`;
  },
  STYLE_QUIZ_ROOMS: `${WAREHOUSE_API_URL}/api/rooms_nested`,
  STYLE_QUIZ: `${WAREHOUSE_API_URL}/api/survey_result`,
  get PARTNERS () {
    return `${this.BASE}/partners`;
  },
  get PARTNER_REFERRAL_QUESTION () {
    return `${this.BASE}/partner_referral_question`;
  },
  DESIGNS_BY_IDS_V2 (idsList) {
    return `${this.BASE}/v2/designs?filter=full&id_list=${idsList}`;
  },
  SHARED_DESIGNS_BY_IDS_V2 (idsList) {
    return `${this.BASE}/v2/designs/shared_list?filter=full&id_list=${idsList}`;
  },
  GET_ORDERS () {
    return `${this.BASE}/api/orders`;
  },
  GET_PRODUCTCATEGORIES () {
    return `${this.BASE}/productcategory`;
  },
  UPDATE_CONTACT_INFO () {
    return `${WAREHOUSE_API_URL}/api/users/update-contact-info`;
  }
};

export default ApiConfig;
